import { useState, useEffect, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";

export function useMovimientos() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [movements, setMovements] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      authAxiosRef.current.get("/financiero/movements"),
      authAxiosRef.current.get("/financiero/accounts"),
    ])
      .then(([mRes, aRes]) => {
        setMovements(mRes.data);
        setAccounts(aRes.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totalIn = movements.filter(m => m.type === "income").reduce((s, m) => s + m.amount, 0);
  const totalOut = movements.filter(m => m.type === "expense").reduce((s, m) => s + m.amount, 0);

  return { movements, accounts, loading, totalIn, totalOut };
}
